import React from 'react';
import { Box, Grid } from '@mui/material';
import DynamicField from './DynamicField';
import InlineSelectionGroup from './InlineSelectionGroup';

// ─── Single-field router ──────────────────────────────────────────────────────
const FieldRenderer = ({ field, fieldData, onChange, errors }) => {
  if (field.type === 'column_group') {
    return <ColumnGroupField field={field} fieldData={fieldData} onChange={onChange} errors={errors} />;
  }
  if (field.type === 'selection_group') {
    return <InlineSelectionGroup field={field} value={fieldData[field.id]} onChange={onChange} error={errors[field.id]} />;
  }
  return <DynamicField field={field} value={fieldData[field.id]} onChange={onChange} error={errors[field.id]} />;
};

// ─── ColumnGroup renderer ─────────────────────────────────────────────────────
// Renders the configured columns side-by-side, matching the dashboard builder.
const ColumnGroupField = ({ field, fieldData, onChange, errors }) => {
  const cols = field.layoutColumns || [];
  if (cols.length === 0) return null;

  const colSize = Math.floor(12 / cols.length);

  return (
    <Grid container spacing={2}>
      {cols.map(col => {
        const colFields = [...(col.fields || [])].sort((a, b) => a.order - b.order).filter(f => !f.hidden);
        return (
          <Grid item key={col.id} xs={12} sm={colSize}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {colFields.map(f => (
                <FieldRenderer key={f.id} field={f} fieldData={fieldData} onChange={onChange} errors={errors} />
              ))}
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

// ─── FieldsStep ───────────────────────────────────────────────────────────────
const FieldsStep = ({ step, fieldData, onChange, errors }) => {
  const sections = [...(step.sections || [])].sort((a, b) => a.order - b.order);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      {sections.map(section => {
        const fields = [...(section.fields || [])].sort((a, b) => a.order - b.order).filter(f => !f.hidden);
        return (
          <Box key={section.id} sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            {fields.map(field => (
              <FieldRenderer key={field.id} field={field} fieldData={fieldData} onChange={onChange} errors={errors} />
            ))}
          </Box>
        );
      })}
    </Box>
  );
};

export default FieldsStep;